import { useState } from 'react'
import Select from 'react-select'

import api from '../../../utils/api'
import Input from '../../../shared/components/form/input'
import Button from '../../../shared/components/Button/Button'
import FormLayout from '../../../shared/components/FormLayout/FormLayout'
import selectStyles from '../../../shared/css/SelectStyle'
import useFlashMessage from '../../../hooks/useFlashMessage'

// isSubcategory só importa na criação (não editando) — distingue os dois botões da tela
// (Categoria/Subcategoria): categoria-mãe nova não mostra o seletor de pai; subcategoria nova
// mostra e exige a escolha. Editando, o seletor sempre aparece (opcional) — dá pra promover uma
// subcategoria a categoria-mãe ou mudar de mãe livremente.
function FormFinanceCategory({ parentOptions, editingCategory, isSubcategory, btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const [name, setName] = useState(editingCategory?.name || '')
    const [parent, setParent] = useState(
        editingCategory?.parent ? parentOptions.find((o) => o.value === editingCategory.parent) || null : null
    )

    const showParentField = !!editingCategory || isSubcategory

    async function submit(e) {
        e.preventDefault()

        if (!name) {
            setFlashMessage('Informe o nome da categoria', 'error')
            return
        }
        if (!editingCategory && isSubcategory && !parent) {
            setFlashMessage('Selecione a categoria-mãe', 'error')
            return
        }

        const body = { name, parent: parent?.value || null }

        let msgType = 'success'
        const request = editingCategory
            ? api.patch(`/finance/category/${editingCategory._id}`, body, { headers: { Authorization: `Bearer ${JSON.parse(token)}` } })
            : api.post('/finance/category/new', body, { headers: { Authorization: `Bearer ${JSON.parse(token)}` } })

        const data = await request.then((response) => response.data).catch((err) => { msgType = 'error'; return err.response.data })

        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') handleOnSuccess()
    }

    function title() {
        if (editingCategory) return 'Editar Categoria'
        return isSubcategory ? 'Nova Subcategoria' : 'Nova Categoria'
    }

    return (
        <FormLayout
            title={title()}
            onSubmit={submit}
            actions={
                <>
                    <Button variant={editingCategory ? 'save' : 'new'} type="submit">{editingCategory ? 'Salvar Alterações' : 'Cadastrar'}</Button>
                    <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                </>
            }
        >
            <div className="fl-row">
                <div className="fl-col-wide form-group">
                    <Input text="Nome" type="text" name="name" placeholder={isSubcategory ? 'Ex.: Limpeza' : 'Ex.: Despesas Operacionais'} handleOnChange={(e) => setName(e.target.value)} value={name} />
                </div>
                {showParentField && (
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Categoria-mãe{!isSubcategory && ' (opcional)'}:</label>
                        <Select
                            options={parentOptions.filter((o) => o.value !== editingCategory?._id)}
                            styles={selectStyles}
                            value={parent}
                            onChange={setParent}
                            isClearable={!isSubcategory || !!editingCategory}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            placeholder={isSubcategory ? 'Selecione a categoria-mãe...' : 'Nenhuma — vira categoria-mãe'}
                        />
                    </div>
                )}
            </div>
        </FormLayout>
    )
}

export default FormFinanceCategory
